import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { SignupComponent } from './components/signup/signup.component';
import { QuotesComponent } from './components/quotes/quotes.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { SetupPasswordComponent } from './components/setup-password/setup-password.component';
import { QuoteComponent } from './components/quote/quote.component';
import { ViewQuoteComponent } from './components/view-quote/view-quote.component';
import { AccountDetailComponent } from './components/account-detail/account-detail.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { TermsOfUseComponent } from './components/terms-of-use/terms-of-use.component';
import { AuthGuard } from './guards/auth.guard';
import { AdminGuard } from './guards/admin.guard';
import { SuperAdminGuard } from './guards/super-admin.guard';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'home', component: HomeComponent },
  { path: 'login', component: LoginComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'setup-password', component: SetupPasswordComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'terms-of-use', component: TermsOfUseComponent },
  {
    // Single "Quotes" surface (Teddy 2026-07-02): quotes and accounts are the same
    // record by status, filtered via the status pill-box. Defaults to the producer's own.
    path: 'quotes',
    component: QuotesComponent,
    canActivate: [AuthGuard],
    data: { view: 'all' }
  },
  {
    // Legacy /accounts → the unified Quotes surface (accounts are a status now).
    path: 'accounts',
    redirectTo: 'quotes',
    pathMatch: 'full'
  },
  {
    // KAN-39 · Customers directory (R2a placeholder — R2b builds out the UX).
    path: 'customers',
    loadComponent: () =>
      import('./components/customers/customers-list.component').then(m => m.CustomersListComponent),
    canActivate: [AuthGuard]
  },
  { path: 'dashboard', redirectTo: 'quotes', pathMatch: 'full' },
  {
    path: 'quote',
    component: QuoteComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'quote/:id',
    component: QuoteComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'view-quote/:id',
    component: ViewQuoteComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'account/:id',
    component: AccountDetailComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'customer',
    loadChildren: () => import('./components/customer/customer.module').then(m => m.CustomerModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./components/admin/admin.module').then(m => m.AdminModule),
    canActivate: [AuthGuard, AdminGuard]
  },
  {
    path: 'super-admin',
    loadChildren: () => import('./components/super-admin/super-admin.module').then(m => m.SuperAdminModule),
    canActivate: [AuthGuard, SuperAdminGuard]
  },
  { path: '**', redirectTo: '/login' }
];
